import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';

const DonutChart = ({ data, title }) => {
  const COLORS = ['#3B82F6', '#EF4444', '#F59E0B', '#10B981'];

  const renderLegend = (props) => {
    const { payload } = props;
    return (
      <div className="grid grid-cols-2 gap-x-3 gap-y-1 justify-items-center mt-4 max-w-md mx-auto">
        {payload.map((entry, index) => (
          <div key={`legend-${index}`} className="flex items-center gap-2">
            <div 
              className="w-3 h-3 rounded-full" 
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-xs text-gray-500">{entry.value}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="h-full flex flex-col outline-none" tabIndex="-1">
      {title && <h3 className="text-lg font-semibold text-center text-black mb-4">{title}</h3>}
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius="60%"
            outerRadius="80%"
            paddingAngle={2}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend content={renderLegend} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DonutChart;
